export default __webpack_public_path__ + "static/media/play.5e083c22.png";